import { useEffect } from 'react'
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'

const useSendDataToGTM = (event, payload) => {
  const send = useGTMDispatch()
  const isThunk = !event && !payload

  useEffect(() => {
    !isThunk && sendDataToGTM(send)(event, payload)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, JSON.stringify(payload)])

  return isThunk && sendDataToGTM(send)
}

const sendDataToGTM = send => (event, payload) => {
  setTimeout(() => {
    send({ event, ...payload })
  }, 100)
}

export default useSendDataToGTM
